import React from 'react';
import { SectionFooterProps } from 'libs/contentful/props';
import SiteFooter from '../Footer/SiteFooter';

/**
 * Renders a footer section that can contain a SiteFooter module
 * Specifically used when we need to render footer modules in one Ninetailed experience
 * @param props - Props including the footer content
 * @returns The rendered footer section component
 */
const SectionFooter = (props: SectionFooterProps & { showFooterKeyline?: boolean }) => {
  if (!props) {
    return null;
  }

  const { footer, showFooterKeyline } = props;

  if (!footer || !footer.__typename) {
    return null;
  }

  switch (footer.__typename) {
    case 'SiteFooter':
      return <SiteFooter {...footer} showFooterKeyline={showFooterKeyline} />;
    default:
      console.warn(`SectionFooter: Unsupported footer type: ${footer.__typename}`);
      return null;
  }
};

export default SectionFooter;
